import { useEffect, useRef } from 'react';
import { useUpdateNodeInternals } from '@xyflow/react';
import type { Node } from '@xyflow/react';
import { changedHandleNodeIds, handleSignatures } from '../lib/flow-editor/handle-signature';
import type { OutputsResolver, WidgetNodeData } from '../widgets/types';

export function useHandleRemeasure(nodes: Node<WidgetNodeData>[], outputsFor: OutputsResolver) {
  const updateNodeInternals = useUpdateNodeInternals();
  const signatures = useRef(new Map<string, string>());

  useEffect(() => {
    const next = handleSignatures(nodes, outputsFor);
    const changed = changedHandleNodeIds(signatures.current, next);
    signatures.current = next;
    if (changed.length > 0) updateNodeInternals(changed);
  }, [nodes, outputsFor, updateNodeInternals]);
}
